import { useLang } from "../i18n";
import { Logo } from "./Logo";
import { Footer } from "./Footer";

const CONTENT = {
  privacy: {
    pl: {
      title: "Polityka prywatności",
      sections: [
        ["Administrator danych", "Administratorem danych osobowych jest Hadron Energy Poland sp. z o.o. z siedzibą w Gdowie (Podolany 88, 32-420 Gdów, Polska). Kontakt w sprawach ochrony danych: contact@hadronenergy.pl, tel. +48 12 2002 588."],
        ["Jakie dane zbieramy", "Za pośrednictwem formularza kontaktowego zbieramy: imię i nazwisko, nazwę firmy, adres e-mail, wybraną kategorię produktu, treść wiadomości oraz pliki, które dobrowolnie załączysz. Zapisujemy również preferencję językową strony — wyłącznie lokalnie, w pamięci Twojej przeglądarki. Nie stosujemy plików cookie śledzących ani narzędzi analitycznych stron trzecich."],
        ["Cel i podstawa prawna przetwarzania", "Dane z formularza przetwarzamy w celu obsługi zapytania, przygotowania oferty i przesłania kart katalogowych (art. 6 ust. 1 lit. b RODO — działania przed zawarciem umowy) oraz w celu zapewnienia bezpieczeństwa i rozliczalności komunikacji (art. 6 ust. 1 lit. f RODO — prawnie uzasadniony interes administratora)."],
        ["Okres przechowywania", "Dane zapytania przechowujemy przez okres niezbędny do jego obsługi, a następnie przez maksymalnie 24 miesiące, po czym je usuwamy."],
        ["Odbiorcy danych", "Dane mogą być powierzane dostawcom usług hostingu i poczty elektronicznej działającym na nasze zlecenie oraz podmiotom grupy Hadron w zakresie niezbędnym do obsługi zapytania. Dane nie są sprzedawane ani przekazywane do celów reklamowych podmiotów trzecich."],
        ["Twoje prawa", "Masz prawo dostępu do swoich danych, ich sprostowania, usunięcia, ograniczenia przetwarzania, przenoszenia danych oraz wniesienia sprzeciwu. Przysługuje Ci również prawo wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych."],
        ["Bezpieczeństwo", "Stosujemy środki techniczne i organizacyjne adekwatne do charakteru przetwarzanych danych, w tym szyfrowanie transmisji (HTTPS) oraz kontrolę dostępu do skrzynki zapytań zabezpieczonej hasłem."],
      ],
    },
    en: {
      title: "Privacy Policy",
      sections: [
        ["Data controller", "The controller of personal data is Hadron Energy Poland sp. z o.o., registered office in Gdów (Podolany 88, 32-420 Gdów, Poland). Data protection contact: contact@hadronenergy.pl, phone +48 12 2002 588."],
        ["What data we collect", "Through the contact form we collect: your name, company name, e-mail address, selected product category, message content and any files you voluntarily attach. We also store your language preference — locally, in your browser only. We do not use tracking cookies or third-party analytics tools."],
        ["Purpose and legal basis", "Form data is processed to handle your inquiry, prepare an offer and send datasheets (Art. 6(1)(b) GDPR — steps prior to entering into a contract) and to ensure the security and accountability of communication (Art. 6(1)(f) GDPR — legitimate interest of the controller)."],
        ["Retention period", "Inquiry data is kept for the time necessary to handle it and for a maximum of 24 months, after which it is deleted."],
        ["Recipients of data", "Data may be entrusted to hosting and e-mail service providers acting on our instructions and to Hadron group entities to the extent necessary to handle the inquiry. Data is never sold or shared for third-party advertising purposes."],
        ["Your rights", "You have the right to access your data, rectify it, erase it, restrict its processing, transfer it and object to its processing. You also have the right to lodge a complaint with your local data protection supervisory authority."],
        ["Security", "We apply technical and organisational measures adequate to the nature of the data processed, including encrypted transmission (HTTPS) and password-protected access to the inquiry inbox."],
      ],
    },
  },
  imprint: {
    pl: {
      title: "Informacje prawne",
      rows: [
        ["Nazwa", "Hadron Energy Poland sp. z o.o."],
        ["Siedziba i zakład produkcyjny", "Podolany 88, 32-420 Gdów, Polska"],
        ["NIP", "6793304582"],
        ["REGON", "529195296"],
        ["KRS", "0001117386"],
        ["Sąd rejestrowy", "Sąd Rejonowy dla Krakowa-Śródmieścia w Krakowie, XI Wydział Gospodarczy KRS"],
        ["Kapitał zakładowy", "400 000 zł"],
        ["E-mail", "contact@hadronenergy.pl"],
        ["Telefon", "+48 12 2002 588"],
      ],
      sections: [
        ["O grupie", "Hadron Energy Poland sp. z o.o. jest spółką większościowo należącą do grupy właścicielskiej z Singapuru, będącej również właścicielem Wuxi Hadron New Energy Tech Co., Ltd. (Chiny). W Gdowie znajdują się europejski zakład montażu, centrum dystrybucji na rynek UE oraz oficjalne centrum serwisu gwarancyjnego i posprzedażnego grupy."],
        ["Informacje o treściach", "Treści niniejszej strony mają charakter informacyjny i nie stanowią oferty w rozumieniu Kodeksu cywilnego. Podane parametry produktów są wartościami typowymi (referencyjnymi) i mogą zostać dostosowane do wymagań projektu na życzenie klienta."],
      ],
    },
    en: {
      title: "Legal information",
      rows: [
        ["Company name", "Hadron Energy Poland sp. z o.o."],
        ["Registered office & production plant", "Podolany 88, 32-420 Gdów, Poland"],
        ["Tax ID (NIP)", "6793304582"],
        ["Statistical number (REGON)", "529195296"],
        ["Court register (KRS)", "0001117386"],
        ["Register court", "District Court for Kraków-Śródmieście in Kraków, 11th Commercial Division of the National Court Register (KRS)"],
        ["Share capital", "PLN 400,000"],
        ["E-mail", "contact@hadronenergy.pl"],
        ["Phone", "+48 12 2002 588"],
      ],
      sections: [
        ["About the group", "Hadron Energy Poland sp. z o.o. is majority-owned by a Singaporean ownership group that also owns Wuxi Hadron New Energy Tech Co., Ltd. (China). The Gdów site hosts the European assembly plant, the EU distribution centre and the group's official warranty and after-sales service hub."],
        ["Information notice", "Content on this website is for information purposes only and does not constitute an offer within the meaning of applicable law. Product specifications are typical reference values and can be customised to project requirements on request."],
      ],
    },
  },
};

function LegalPage({ kind }) {
  const { lang } = useLang();
  const c = CONTENT[kind][lang === "pl" ? "pl" : "en"];
  const back = lang === "pl" ? "Powrót do strony głównej" : "Back to homepage";

  const goHome = () => {
    window.location.hash = "#/";
  };

  return (
    <div className="bg-ink text-txt font-body min-h-screen flex flex-col" data-testid="legal-page">
      <header className="sticky top-0 z-40 border-b border-line bg-ink/90 backdrop-blur-md">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 py-3.5 flex items-center justify-between gap-4">
          <button data-testid="legal-home-logo" onClick={goHome} aria-label="Hadron Energy — home" className="shrink-0">
            <Logo />
          </button>
          <button data-testid="legal-home-link" onClick={goHome} className="font-mono2 text-[11px] uppercase tracking-[0.18em] text-txt-2 hover:text-hadron-cyan transition-colors">
            &larr; {back}
          </button>
        </div>
      </header>

      <main className="flex-1 mx-auto w-full max-w-3xl px-4 sm:px-6 py-16 lg:py-20">
        <h1 className="font-display uppercase font-bold tracking-tight leading-[0.95] text-3xl sm:text-4xl lg:text-5xl" data-testid="legal-title">
          {c.title}
        </h1>
        <div className="mt-10 space-y-9">
          {c.rows && (
            <dl className="border border-line rounded-lg overflow-hidden">
              {c.rows.map(([k, v], i) => (
                <div key={k} className={`grid sm:grid-cols-[220px_1fr] gap-1 sm:gap-4 px-4 sm:px-5 py-3.5 ${i % 2 ? "bg-ink-2/40" : ""}`}>
                  <dt className="font-mono2 text-[10px] uppercase tracking-[0.18em] text-txt-3 pt-0.5">{k}</dt>
                  <dd className="text-sm text-txt break-words">{v}</dd>
                </div>
              ))}
            </dl>
          )}
          {c.sections && c.sections.map(([h, body]) => (
            <section key={h}>
              <h2 className="font-display uppercase font-bold text-lg text-txt">{h}</h2>
              <p className="mt-2.5 text-sm leading-relaxed text-txt-2">{body}</p>
            </section>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default LegalPage;
